import React from 'react';
import { ModuleContentTemplate } from './ModuleContentTemplate';
import { module1Config } from '../config/moduleConfigs';

interface User {
  id: string;
  email: string;
  fullName: string;
  company: string;
  role: string;
  status: string;
}

interface Module1ContentNewProps {
  user: User | null;
  onLogout: () => void;
  isPreviewMode?: boolean;
  invitationEmail?: string;
  isAdminMode?: boolean;
  inviteToken?: string;
}

export function Module1ContentNew({ 
  user, 
  onLogout, 
  isPreviewMode = false, 
  invitationEmail, 
  isAdminMode = false, 
  inviteToken 
}: Module1ContentNewProps) {
  return (
    <ModuleContentTemplate
      user={user}
      onLogout={onLogout}
      moduleId={1}
      moduleConfig={module1Config}
      isPreviewMode={isPreviewMode}
      invitationEmail={invitationEmail}
      isAdminMode={isAdminMode}
      inviteToken={inviteToken}
    />
  );
}

